import PointLayer from "./PointLayer";

export default class ProjectLayer extends PointLayer {
    constructor(map, data, options = {}) {
        // super(map, data, 'Project', options = {height: 42,nodeRender: 'GIS'});
        super(map, data, 'Project', options = {height: 42, scale: 0.4});
        this.mapTooltip = null;
    }

    handlerNode(node, info) {
        node.a({
            'name': info.name,
            'progress': info.progress / 100,
        });
    }

    showLayer() {
        super.show();
    }

    hideLayer() {
        super.hide();
    }

    resetLayer() {
        if(this.mapTooltip) {
            this.mapTooltip.remove();
            this.mapTooltip = null;
        }
    }

    showPointInfo(node) {
        if(this.mapTooltip) {
            this.mapTooltip.remove();
            this.mapTooltip = null;
        }
        const coord = node.getCoordinate();
        const info = node.a('properties');

        this.map.flyToTarget(node, {
            animation: {
                finishFunc: () => {
                    const node = this.mapTooltip = new ht.cesium.Node({
                        id: 'project-tooltip-info',
                        nodeRender: 'GIS_HT',
                        lnglat: [coord[0], coord[1]],
                        height: coord[2] + 10,
                        scale: 0.3,
                    });
                    this.map.add(node);
                    node.s({
                        'interactive': false,
                        '2d.selectable': false,
                        '3d.selectable': false,
                        'shape3d': 'billboard',
                        'shape3d.image': 'symbols/smart-park/panel/项目详细信息.json',
                        'autorotate': true,
                        'shape3d.fixSizeOnScreen': false,
                        'shape3d.transparent': true,
                        'vector.dynamic': true,
                        '3d.clip.direction': 'right',
                        '3d.clip.percentage': 0
                    });
                    node.a({
                        code: info.id,
                        name: info.name,
                        cost: info.cost,
                        status: info.status,
                        progress: info.progress
                    });
                    node.setAnchor3d([-0.1,0.5,0.5]);
                    // node.setRenderLayer('top');
                    ht.Default.startAnim({
                        delay: 200,
                        duration: 1000,
                        easing: t => t,
                        action: v => {
                            this.mapTooltip && this.mapTooltip.s('3d.clip.percentage', v);
                        }
                    });
                }
            },
            distance: 260
        });
    }
}